import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    antecedentesPatologicos: [],
  },

  getters: {
    getAntecedentesPatologicos: (state) => state.antecedentesPatologicos,
  },

  mutations: {
    SET_ANTECEDENTES_PATOLOGICOS(state, antecedentesPatologicos) {
      state.antecedentesPatologicos = antecedentesPatologicos;
    },
  },

  actions: {
    async fetchAntecedentesPatologicos({ commit }, idHistoriaClinica) {
      await axios
        .get(`PoliciaCuadrantes/C3/historiasclinicas/${idHistoriaClinica}/antecedentesPatologicos`)
        .then((response) => {
          commit('SET_ANTECEDENTES_PATOLOGICOS', response.data.data);
        });
    },

    async saveAntecedentesPatologicos(context, antecedentesPatologicos) {
      const { idHistoriaClinica } = context.rootState.historiaClinica;
      await axios
        .post(`PoliciaCuadrantes/C3/historiasclinicas/${idHistoriaClinica}/antecedentesPatologicos`, antecedentesPatologicos);
    },

    async updateAntecedentesPatologicos(_, antecedentesPatologicos) {
      await axios
        .put(
          `PoliciaCuadrantes/C3/historiasclinicas/${
            antecedentesPatologicos.fk_idHistoriaClinica
          }/antecedentesPatologicos/${
            antecedentesPatologicos.fk_idAntecedentesPatologicos}`,
          antecedentesPatologicos,
        );
    },
  },
};
